import type { IJBPPlanning } from '../../models/IJBPPlanning'

export const getPlanningCurrency = (
  planningData: Pick<IJBPPlanning, 'IsTarget' | 'Currency'>[],
  hasMultiLocalCurrencies: boolean
): string | undefined =>
  hasMultiLocalCurrencies ? 'USD' : planningData.find((item) => !!item.IsTarget)?.Currency
